/** @description 配置的一套默认的模板 */
export const defaultFolder = {
  id: 'root',
  name: '{项目地址}',
  nameFields: [
    {
      type: 'template',
      value: '{address}',
    },
  ],
  nameLimitSize: 60,
  startNum: 1,
  pid: '',
  isFolder: true,
  accept: {
    classifyChains: [],
    supportedFiles: [],
  },
  children: [
    {
      id: 'PWa5bHgYxbl_tEKIMS-kV',
      name: '雕刻机文件',
      nameFields: [
        {
          type: 'text',
          value: '雕刻机文件',
        },
      ],
      nameLimitSize: 60,
      pid: 'root',
      children: [],
      isFolder: true,
      startNum: 1,
      accept: {
        classifyChains: [],
        supportedFiles: [
          {
            id: 'klDFzAvPUbBHFMavQVB5i',
            isFile: true,
            name: '雕刻机正面文件',
            type: 'engraving_front',
            pid: 'PWa5bHgYxbl_tEKIMS-kV',
            metadata: {},
            ext: '.nc',
          },
          {
            id: 'WpG3pJRx2-iXOmmlB1VDV',
            isFile: true,
            name: '雕刻机反面文件',
            type: 'engraving_opposite',
            pid: 'PWa5bHgYxbl_tEKIMS-kV',
            metadata: {},
            ext: '.nc',
          },
          {
            id: '73SOcxEScTjkbM_ZaOfMq',
            isFile: true,
            name: '雕刻机合并文件',
            type: 'engraving_merge',
            pid: 'PWa5bHgYxbl_tEKIMS-kV',
            metadata: {},
            ext: '.nc',
          },
        ],
      },
      metadata: {},
    },
    {
      id: '5LtMVnHu_5GHP2tgqkYj9',
      name: '电子锯文件',
      nameFields: [
        {
          type: 'text',
          value: '电子锯文件',
        },
      ],
      nameLimitSize: 60,
      pid: 'root',
      children: [],
      isFolder: true,
      startNum: 1,
      accept: {
        classifyChains: [],
        supportedFiles: [
          {
            id: '6SDlUrJm4bwK2_dBORrQ4',
            isFile: true,
            name: '电子锯文件',
            type: 'electronic_saw',
            pid: '5LtMVnHu_5GHP2tgqkYj9',
            metadata: {},
            ext: '.nc',
          },
        ],
      },
      metadata: {},
    },
    {
      id: '6l9GuXrZN1aRItwND9Ha3',
      name: '侧孔机文件-云排版',
      nameFields: [
        {
          type: 'text',
          value: '侧孔机文件-云排版',
        },
      ],
      nameLimitSize: 60,
      pid: 'root',
      children: [],
      isFolder: true,
      startNum: 1,
      accept: {
        classifyChains: [],
        supportedFiles: [
          {
            id: 'mGbue5nmjJsRn8l8iXfOy',
            isFile: true,
            name: '侧孔机文件',
            type: 'side_machine',
            pid: '6l9GuXrZN1aRItwND9Ha3',
            metadata: {},
            ext: '.nc',
          },
        ],
      },
      metadata: {},
    },
    {
      id: 'rph6X6l1LGxbgbsC9iwjW',
      name: '侧孔机文件-旧版',
      nameFields: [
        {
          type: 'text',
          value: '侧孔机文件-旧版',
        },
      ],
      nameLimitSize: 60,
      pid: 'root',
      children: [],
      isFolder: true,
      startNum: 1,
      accept: {
        classifyChains: [],
        supportedFiles: [
          {
            id: '0-bhU2vbGpV4eH721j24m',
            isFile: true,
            name: '旧版侧孔机XML3文件',
            type: 'side_machine_xml3',
            pid: 'rph6X6l1LGxbgbsC9iwjW',
            metadata: {},
            ext: '.nc',
          },
          {
            id: 'fH4zl4qqx0T4er4gUvGnd',
            isFile: true,
            name: '旧版侧孔机nc文件',
            type: 'side_machine_nc',
            pid: 'rph6X6l1LGxbgbsC9iwjW',
            metadata: {},
            ext: '.nc',
          },
          {
            id: 'ZpxfaPpO5Dqy4zak76eLF',
            isFile: true,
            name: '旧版侧孔机TXT文件',
            type: 'side_machine_txt',
            pid: 'rph6X6l1LGxbgbsC9iwjW',
            metadata: {},
            ext: '.nc',
          },
        ],
      },
      metadata: {},
    },
    {
      id: 'YlU4jrGxPub5Jk4FaUTCQ',
      name: '五六面钻文件',
      nameFields: [
        {
          type: 'text',
          value: '五六面钻文件',
        },
      ],
      nameLimitSize: 60,
      pid: 'root',
      children: [],
      isFolder: true,
      startNum: 1,
      accept: {
        classifyChains: [],
        supportedFiles: [
          {
            id: 'TqRtWcP5v6acXjw8bYk-m',
            isFile: true,
            name: '五/六面钻文件',
            type: 'dock56F',
            pid: 'YlU4jrGxPub5Jk4FaUTCQ',
            metadata: {},
            ext: '.xml',
          },
        ],
      },
      metadata: {},
    },
    {
      id: 'DDBBkvwlsm316Fe7NCTbi',
      name: 'PTP文件',
      nameFields: [
        {
          type: 'text',
          value: 'PTP文件',
        },
      ],
      nameLimitSize: 60,
      pid: 'root',
      children: [],
      isFolder: true,
      startNum: 1,
      accept: {
        classifyChains: [],
        supportedFiles: [
          {
            id: 'Cwz8y15R2_lmWqVCssJA5',
            isFile: true,
            name: 'PTP文件',
            type: 'ptp',
            pid: 'DDBBkvwlsm316Fe7NCTbi',
            metadata: {},
            ext: '.nc',
          },
        ],
      },
      metadata: {},
    },
    {
      id: '53AnJbs6Kd7LF36s79iaL',
      name: '一体机文件',
      nameFields: [
        {
          type: 'text',
          value: '一体机文件',
        },
      ],
      nameLimitSize: 60,
      pid: 'root',
      children: [],
      isFolder: true,
      startNum: 1,
      accept: {
        classifyChains: [],
        supportedFiles: [
          {
            id: 'cnTLCE5sq5QlJiq7waeZu',
            isFile: true,
            name: '一体机文件',
            type: 'aio',
            pid: '53AnJbs6Kd7LF36s79iaL',
            metadata: {},
            ext: '.nc',
          },
          {
            id: 'l-LLjXiRuStkhcgnYe-Mu',
            isFile: true,
            name: '一体机正面anc文件',
            type: 'aio_anc',
            pid: '53AnJbs6Kd7LF36s79iaL',
            metadata: {},
            ext: '.nc',
          },
        ],
      },
      metadata: {},
    },
    {
      id: '_QYeTUzFOnhgnuBB9gVBW',
      name: '玻璃切割机文件',
      nameFields: [
        {
          type: 'text',
          value: '玻璃切割机文件',
        },
      ],
      nameLimitSize: 60,
      pid: 'root',
      children: [],
      isFolder: true,
      startNum: 1,
      accept: {
        classifyChains: [],
        supportedFiles: [
          {
            id: 'TD8TY7fzOnjgLN7XXZc_r',
            isFile: true,
            name: '玻璃切割机文件',
            type: 'glass',
            pid: '_QYeTUzFOnhgnuBB9gVBW',
            metadata: {},
            ext: 'opt',
          },
        ],
      },
      metadata: {},
    },
    {
      id: 'bcESZG9VUn-npDmd9-Ca6',
      name: '贴标机文件',
      nameFields: [
        {
          type: 'text',
          value: '贴标机文件',
        },
      ],
      nameLimitSize: 60,
      pid: 'root',
      children: [],
      isFolder: true,
      startNum: 1,
      accept: {
        classifyChains: [],
        supportedFiles: [
          {
            id: 'X_5YlLjukVYE7Urc6_DyF',
            isFile: true,
            name: '贴标机文件1',
            type: 'labeling_1',
            pid: 'bcESZG9VUn-npDmd9-Ca6',
            metadata: {},
            ext: '.xml',
          },
          {
            id: 'dww3JKrM3YcQprDjHCqL7',
            isFile: true,
            name: '贴标机文件2',
            type: 'labeling_2',
            pid: 'bcESZG9VUn-npDmd9-Ca6',
            metadata: {},
            ext: '.xml',
          },
          {
            id: 'rKy8k9eD05Xbp4BvZvb7K',
            isFile: true,
            name: '贴标机文件3',
            type: 'labeling_3',
            pid: 'bcESZG9VUn-npDmd9-Ca6',
            metadata: {},
            ext: '.xml',
          },
        ],
      },
      metadata: {},
    },
    {
      id: 'zBGdvM5gq9l-Zm03NB6Pb',
      name: '标签文件',
      nameFields: [
        {
          type: 'text',
          value: '标签文件',
        },
      ],
      nameLimitSize: 60,
      pid: 'root',
      children: [],
      isFolder: true,
      startNum: 1,
      accept: {
        classifyChains: [],
        supportedFiles: [
          {
            id: 'YKjYTt7lDE0N80KLBmzLA',
            isFile: true,
            name: '标签图片文件',
            type: 'label_image',
            pid: 'zBGdvM5gq9l-Zm03NB6Pb',
            metadata: {},
            ext: '.jpg',
          },
          {
            id: 'HU9ExupjmuSYV1FgDeitK',
            isFile: true,
            name: '标签PDF文件',
            type: 'label_pdf',
            pid: 'zBGdvM5gq9l-Zm03NB6Pb',
            metadata: {},
            ext: '.pdf',
          },
          {
            id: 'Dwx2UX9izvpIy5NTNk0G2',
            isFile: true,
            name: '排版图图片文件',
            type: 'paiban_image',
            pid: 'zBGdvM5gq9l-Zm03NB6Pb',
            metadata: {},
            ext: '.jpg',
          },
          {
            id: '7_a-_GRvP_xnE6GvtVzib',
            isFile: true,
            name: '排版图PDF文件',
            type: 'paiban_pdf',
            pid: 'zBGdvM5gq9l-Zm03NB6Pb',
            metadata: {},
            ext: '.pdf',
          },
        ],
      },
      metadata: {},
    },
    {
      id: 'pAgBvloIwRfmd4mXBnwLj',
      name: '雕刻机二次加工文件',
      nameFields: [
        {
          type: 'text',
          value: '雕刻机二次加工文件',
        },
      ],
      nameLimitSize: 60,
      pid: 'root',
      children: [],
      isFolder: true,
      startNum: 1,
      accept: {
        classifyChains: [],
        supportedFiles: [
          {
            id: 'OGF6rsxztM2slktHuGO3Z',
            isFile: true,
            name: '二次加工牛角槽铣槽',
            type: 'engraving_mill',
            pid: 'pAgBvloIwRfmd4mXBnwLj',
            metadata: {},
            ext: '.nc',
          },
          {
            id: 'qCKfAFu4qAUAo9vvYqype',
            isFile: true,
            name: '二次加工斜边海棠角和斜边拉手文件',
            type: 'engraving_handle',
            pid: 'pAgBvloIwRfmd4mXBnwLj',
            metadata: {},
            ext: '.nc',
          },
          {
            id: '7LQFRO61WBX8hpPKrkPJG',
            isFile: true,
            name: '二次加工铣底圆弧槽',
            type: 'engraving_arc_slot',
            pid: 'pAgBvloIwRfmd4mXBnwLj',
            metadata: {},
            ext: '.nc',
          },
          {
            id: 'WqO88pYn7n85FZGm09O3J',
            isFile: true,
            name: '二次加工自定义刀路',
            type: 'engraving_line_slot',
            pid: 'pAgBvloIwRfmd4mXBnwLj',
            metadata: {},
            ext: '.nc',
          },
          {
            id: 'FbiiX0h3ng7gQdtUGVafK',
            isFile: true,
            name: '二次加工圆弧折弯部分直槽',
            type: 'engraving_straight_arc_slot',
            pid: 'pAgBvloIwRfmd4mXBnwLj',
            metadata: {},
            ext: '.nc',
          },
          {
            id: '_np6QE61cIRH59ZVWjcvd',
            isFile: true,
            name: '二次加工骨骼门文件',
            type: 'engraving_frame_door',
            pid: 'pAgBvloIwRfmd4mXBnwLj',
            metadata: {},
            ext: '.nc',
          },
          {
            id: 'EgTzI8nkA5heV3M4ZSIfw',
            isFile: true,
            name: '二次加工内部异形',
            type: 'engraving_inner_shape',
            pid: 'pAgBvloIwRfmd4mXBnwLj',
            metadata: {},
            ext: '.nc',
          },
          {
            id: 'hZXFslMt-cPK0OMFfjfeH',
            isFile: true,
            name: '二次加工常规孔',
            type: 'engraving_hole',
            pid: 'pAgBvloIwRfmd4mXBnwLj',
            metadata: {},
            ext: '.nc',
          },
          {
            id: 'GfsIBqUhPns80hJbyHl9k',
            isFile: true,
            name: '二次加工常规槽',
            type: 'engraving_slot',
            pid: 'pAgBvloIwRfmd4mXBnwLj',
            metadata: {},
            ext: '.nc',
          },
          {
            id: 'qhC1xkkTSj_UCjx4S7-Vx',
            isFile: true,
            name: '二次加工合并文件',
            type: 'engraving_single_file_merge',
            pid: 'pAgBvloIwRfmd4mXBnwLj',
            metadata: {},
            ext: '.nc',
          },
        ],
      },
      metadata: {},
    },
    {
      id: '9auZaiKHU9N1ZDiLfmNGN',
      name: '机械臂文件',
      nameFields: [
        {
          type: 'text',
          value: '机械臂文件',
        },
      ],
      nameLimitSize: 60,
      pid: 'root',
      children: [],
      isFolder: true,
      startNum: 1,
      accept: {
        classifyChains: [],
        supportedFiles: [
          {
            id: 'FTUIfP3vrlhm471B1cXsh',
            isFile: true,
            name: '机械臂文件',
            type: 'robotic_arm',
            pid: '9auZaiKHU9N1ZDiLfmNGN',
            metadata: {},
            ext: '.nc',
          },
        ],
      },
      metadata: {},
    },
    {
      id: '0s4a3T3oUlG6sSgi2KliL',
      name: '门墙柜一体机',
      nameFields: [
        {
          type: 'text',
          value: '门墙柜一体机',
        },
      ],
      nameLimitSize: 60,
      pid: 'root',
      children: [],
      isFolder: true,
      startNum: 1,
      accept: {
        classifyChains: [],
        supportedFiles: [
          {
            id: 'HvVnflF3xJpQr_TEaKz6u',
            isFile: true,
            name: '门墙柜一体机',
            type: 'door_wall',
            pid: '0s4a3T3oUlG6sSgi2KliL',
            metadata: {},
            ext: '.nc',
          },
        ],
      },
      metadata: {},
    },
  ],
  metadata: {},
}
/** @description 根目录使用的 id */
export const ROOT_ID = 'root'
